/*
 * Copyright (C) 2018 Paymentus Inc.
 *
 * All rights reserved.
 *
 * The source code in this file is confidential and is the sole property of
 * Paymentus Inc. Its use is restricted to those readers who are authorized by
 * the corporation. Any reverse engineering or reproduction or divulgence of the
 * content of this report without the written consent from Paymentus Inc. is
 * strictly prohibited.
 *
 * Created on 8/20/18 2:20 PM
 * Created by kxian
 *
 */


import checkAppContext from '../lib/check-context';
checkAppContext();

import App from './rotp-opp-state';
import ReactDOM from "react-dom";
import React from "react";

ReactDOM.render(
    <App />,
    document.getElementById('root')
);